import React, { PropsWithChildren, useState } from 'react';
import theme from './SplashPage.module.scss';
import { useSelector } from 'react-redux';
import { IState } from '@/state/IState';
import { FrontEndConfiguration } from '@/types';
import { getProjectHeaderImageUrl } from '@/services/projects';
import { getProfileBackgroundImageUrl } from '@/services/profiles';
import { PageTitle } from '@/components/layout/PageTitle';
import { classnames } from '@/utils/html';

interface SplashPageProps extends PropsWithChildren {
    backgroundImageUrl?: string | null;
}

function getBackgroundImageUrl(configuration: FrontEndConfiguration | null) {
    if (!configuration) {
        return null;
    }

    if (configuration.projectId) {
        return getProjectHeaderImageUrl(configuration.projectId);
    }

    if (configuration.profileId) {
        return getProfileBackgroundImageUrl(configuration.profileId);
    }

    return null;
}

const SplashPage: React.FC<SplashPageProps> = ({ children, backgroundImageUrl }) => {
    const config = useSelector((state: IState) => state.global.configuration);
    const [imageHasLoaded, setImageHasLoaded] = useState(false);

    if (!backgroundImageUrl) {
        backgroundImageUrl = getBackgroundImageUrl(config);
    }
    return (
        <div className={theme.container}>
            <PageTitle transparent />
            {/* <PageTitle transparent>
                <ExternalLink href="https://www.bygr.io" className={classnames(theme.logo, 'link-unstyled')}>
                    <Icon name="logo-big" />
                </ExternalLink>
            </PageTitle> */}

            {backgroundImageUrl ? (
                <div className={classnames(theme.backgroundImage, { [theme.imageHasLoaded]: imageHasLoaded })}>
                    <img onLoad={() => setImageHasLoaded(true)} alt="Background" src={backgroundImageUrl} />
                </div>
            ) : (
                <svg className={theme.rubusSplash} width="337" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g transform="translate(0,100)">
                        <path
                            d="M-155.949 -163.126C-124.855 -197.994 -100.311 -245.68 -87.1174 -292.258C-74.9098 -371.501 -82.3341 -539.685 -209.692 -578.476L231.585 -578.476C120.066 -455.169 119.229 -284.297 229.52 -160.345C340.518 -35.5871 341.057 143.206 230.729 267.944C195.057 308.273 168.038 354.287 156.017 408.866C131.138 521.793 164.893 614.726 237.745 696.514C328.069 797.953 337.689 959.998 263.368 1073.67C186.758 1190.85 45.6893 1233.42 -75.4129 1176.46C-261.383 1089.01 -286.579 828.105 -158.015 684.442C-44.207 557.265 -48.0588 394.737 -160.62 267.48C-267.989 146.088 -263.393 -42.6815 -155.949 -163.126Z"
                            fill="#FF4843"
                        />
                        <path
                            d="M-172.143 65.2383C-138.451 30.3799 -111.856 -17.2936 -97.56 -63.8588C-84.3323 -143.081 -92.377 -311.22 -230.377 -350L247.772 -350C126.935 -226.726 126.028 -55.8998 245.534 68.0188C365.807 192.743 366.391 371.489 246.845 496.193C208.192 536.512 178.916 582.513 165.89 637.077C138.932 749.974 175.508 842.883 254.446 924.649C352.318 1026.06 362.742 1188.06 282.211 1301.7C199.2 1418.85 46.3436 1461.41 -84.8775 1404.47C-286.387 1317.04 -313.688 1056.2 -174.381 912.58C-51.0641 785.437 -55.2378 622.953 -177.204 495.73C-293.545 374.37 -288.565 185.651 -172.143 65.2383Z"
                            fill="#501132"
                        />
                    </g>
                </svg>
            )}

            <div className={theme.content}>{children}</div>
        </div>
    );
};

export default SplashPage;
{
    /* <svg width="337" height="1117" viewBox="0 0 337 1117" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M-172.143 65.2383C-138.451 30.3799 -111.856 -17.2936 -97.56 -63.8588C-84.3323 -143.081 -92.377 -311.22 -230.377 -350L247.772 -350C126.935 -226.726 126.028 -55.8998 245.534 68.0188C365.807 192.743 366.391 371.489 246.845 496.193C208.192 536.512 178.916 582.513 165.89 637.077C138.932 749.974 175.508 842.883 254.446 924.649C352.318 1026.06 362.742 1188.06 282.211 1301.7C199.2 1418.85 46.3436 1461.41 -84.8775 1404.47C-286.387 1317.04 -313.688 1056.2 -174.381 912.58C-51.0641 785.437 -55.2378 622.953 -177.204 495.73C-293.545 374.37 -288.565 185.651 -172.143 65.2383Z" fill="#501132"/>
</svg> */
}
